import React from 'react';
import {
    Navigate,
    Outlet,
    useLocation
} from 'react-router-dom';

import { useAuth } from "contexts";

export const PublicRoutes = ({ redirectPath = "/accueil" }) => {
    const location = useLocation();
    const { auth } = useAuth();

    const isPaymentRoute = location.pathname.startsWith("/p");
    if( isPaymentRoute ) {
        return <Outlet />;
    }

    let target = redirectPath;
    if( auth.isAuth && location?.state?.from?.pathname && location.state.from.pathname !== redirectPath ){
        target = location.state.from.pathname;
    }

    return auth.isAuth ? <Navigate to={target} state={{ from: location }} replace /> : <Outlet /> ;
}

export const ProtectedRoutes = ({ redirectPath = "/login" }) => {
    const location = useLocation();
    const { auth } = useAuth();

    return auth.isAuth ? <Outlet/> : <Navigate to={redirectPath} state={{ from: location }} replace /> ;
};